import { useEffect, useState } from "react";
import { Menu, Tabs } from "antd";
import type { MenuProps, TabsProps } from "antd";
import useWindowSize from "helpers/useWindowSize";

type MenuItem = Required<MenuProps>["items"][number];

interface ResponsiveMenuProps {
  menuItems: MenuItem[];
  currentStep: any;
  setCurrentStep: (step: number) => void;
  defaultSelectedKeys?: string[];
  onClick?: MenuProps["onClick"];
  containerRef: any;
}

const ResponsiveMenu: React.FC<ResponsiveMenuProps> = ({
  menuItems,
  currentStep,
  setCurrentStep,
  containerRef,
  defaultSelectedKeys = ["0"],
  onClick,
}) => {
  const [menuMode, setMenuMode] = useState<"horizontal" | "vertical">("vertical");
  const windowSize = useWindowSize(containerRef);

  useEffect(() => {
    if (windowSize.width < 1040) {
      setMenuMode("horizontal");
    } else {
      setMenuMode("vertical");
    }
  }, [windowSize.width]);

  // Tabs için uygun formatta data oluştur
  const tabItems: TabsProps["items"] = menuItems.map((item:any, index) => ({
    key: item.key,
    label: item?.label as string, 
    children: null, 
    icon:item?.icon,
  }));

  return (
    <div className="!w-full">
      {menuMode === "horizontal" ? (
        <Tabs
          activeKey={`${currentStep}`}
          onChange={(key:any) =>{
            setCurrentStep(key)
          }}
          items={tabItems}
        />
      ) : (
        <Menu
          className="xl:!h-screen"
          mode="vertical"
          defaultSelectedKeys={defaultSelectedKeys}
          selectedKeys={[`${currentStep}`]}
          items={menuItems}
          onClick={onClick}
        />
      )}
    </div>
  );
};

export default ResponsiveMenu;
